/**
 * components/landing/trust/_shared.js — shared tone tokens for Phase 11.
 *
 * Mirrors the palette in company/_shared.js so any tone key we use in
 * data.js maps to a consistent hex + rgb pair for glow/gradient math.
 */
export const TONE = {
  orange: { hex: '#FFC107', rgb: '243,112,33'  },
  green:  { hex: '#22c55e', rgb: '34,197,94'   },
  blue:   { hex: '#3b82f6', rgb: '59,130,246'  },
  purple: { hex: '#a855f7', rgb: '168,85,247'  },
  cyan:   { hex: '#22d3ee', rgb: '34,211,238'  },
  rose:   { hex: '#f43f5e', rgb: '244,63,94'   },
  amber:  { hex: '#f59e0b', rgb: '245,158,11'  },
  emerald:{ hex: '#10b981', rgb: '16,185,129'  },
}
export {}
